// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"81b8b004","239":"4c44b0cb","453":"f2cb47f8","455":"4db87556"}[chunkId] + ".chunk.js";
};